import { AuditCard } from "@/features/Audit/AuditCard";
import { Clients } from "@/lib/clients";
import { Tables } from "@/gen/tableNames/tables";
import i18n from "@/i18n";
import { useParams } from "react-router-dom";
import { C5IssuersEditCard } from "./edit_card";

export const C5IssuersEdit = () => {
  const { id } = useParams<{ id: string }>();

  if (!id) {
    return <div>{i18n.t("errors.invalid_id")}</div>;
  }

  return (
    <div className="bg-gray-50 relative">
      <div className="flex flex-col gap-10 p-10">
        <C5IssuersEditCard
          id={Number(id)}
          client={Clients.C5}
          table_name={Tables.C5_ISSUERS}
        />
        <AuditCard
          id={Number(id)}
          client={Clients.C5}
          audit_table_name={Tables.C5_ISSUERS}
        />
      </div>
    </div>
  );
};
